var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 이력 노출 유무 "), _vm.mode == 'form' ? _c('span', {
    staticClass: "page-text--sm grey-6--text pl-8 font-weight-regular"
  }, [_vm._v("마이스펙인증 이력을 해당 이력서에 포함시킬지 확인해주세요")]) : _vm._e()]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-btn', {
    staticClass: "px-19 mt-12 mb-n12",
    attrs: {
      "text": "",
      "large": ""
    },
    on: {
      "click": _vm.toggleAll
    }
  }, [_c('v-simple-checkbox', {
    attrs: {
      "value": _vm.isSelectedAll,
      "color": "primary"
    },
    on: {
      "click": _vm.toggleAll
    }
  }), _vm._v(" 전체선택 ")], 1), _c('v-sheet', [_vm._l(_vm.applications, function (item) {
    return [_c('micepec-record-item', _vm._b({
      key: item._id,
      staticClass: "my-24",
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.selected,
        callback: function callback($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    }, 'micepec-record-item', {
      item: item,
      mode: _vm.mode
    }, false))];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }